<!--<div id="heroheader" class="flex align-items-center justify-content-between">-->
<ng-container *ngIf="!['/registration'].includes(currentRoute)">
  <p-menubar [styleClass]="'heroheader'" class="print-none">
    <ng-template pTemplate="start">
      <div class="flex align-items-center burger-icon">
        <h2 (click)="toggleSidebar()"><i class="fa-solid fa-bars mr-5"></i></h2>
        <a [routerLink]="['/']"><img src="../assets/southgalaxy_logo_2.png" id="financia-logo"></a>
        <!-- <h2 class="m-2">Prime Lash</h2> -->
        <!--        <a [routerLink]="['/']"><img src="../assets/kitLogoWhite.png" id="financia-logo"></a>-->
      </div>
    </ng-template>
    <ng-template pTemplate="end">
      <div class="flex align-items-center" *ngIf="isUserLoggedIn">
        <p class="m-0">{{appUser?.firstName + " " + appUser?.lastName | titlecase}}</p>
        <button pButton label="Log Out" class="ml-4 LOGOUT-BTN" (click)="LogOut()"></button>
      </div>
    </ng-template>
  </p-menubar>
  
  <p-sidebar #sidebar [(visible)]="sidebarState" [style.width]="'30vw'" styleClass="p-pl-3 p-pt-3" [class]="'side-nav'"
             [blockScroll]="true">
    <!--  <p-panelMenu [model]="items" [style]="{'width':'100%'}" [multiple]="true"></p-panelMenu>-->
    <ng-container *ngFor="let item of items">
      <ng-container *ngIf="item.visible">
        <div class="p-3">
          <span class="item-header">{{item.label}}</span>
        </div>
        <!--      <p-divider *ngIf="item.items?.length"></p-divider>-->
        <div *ngFor="let cItem of item.items" class="item-container" (click)="navigateToLink(cItem.routerLink)">
          <div class="p-2" *ngIf="cItem.visible">
            <div class="flex align-content-center align-items-center">
              <div class="icon-container flex align-items-center justify-content-center shadow-1 mr-4">
                <i [class]="cItem.icon"></i>
              </div>
              <p>{{cItem.label}}</p>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <br/>
  </p-sidebar>
</ng-container>
<!--</div>-->
<div id="container">
  <!--  <div class="flex align-items-center justify-content-between mb-3">-->
  <!--    <div>-->
  <!--      <img src="../assets/Financia.svg" id="financia-logo">-->
  <!--      <p class="m-0">Hello, {{app_user?.firstName + " " + app_user?.lastName | titlecase}}</p>-->
  <!--    </div>-->
  <!--    <div>-->
  <!--      <button pButton label="Log Out" class="p-button-warning" (click)="LogOut()"></button>-->
  <!--    </div>-->
  <!--  </div>-->
  <router-outlet></router-outlet>
</div>
<app-loader></app-loader>

<p-confirmDialog key="500Dialog" appendTo="body" [baseZIndex]="900000">
  <ng-template pTemplate="header">
    <div class="flex justify-content-between">
      <div class="text-lg font-semibold">Sorry!</div>
    </div>
  </ng-template>
<!--  <ng-template pTemplate="footer">-->
<!--    <div class="text-xs text-500">{{errorCode || ''}}</div>-->
<!--  </ng-template>-->
</p-confirmDialog>

<p-toast styleClass="w-11 md:w-auto"></p-toast>
